'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Hamburger = undefined;

var _Hamburger2 = require('./Hamburger');

var _Hamburger3 = _interopRequireDefault(_Hamburger2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.Hamburger = _Hamburger3.default; /**
                                          * Created by maximus on 15.11.16.
                                          */


//////////////////
// WEBPACK FOOTER
// ./src/components/Hamburger/index.js
// module id = 1673
// module chunks = 0